const isKeydownClick = (e: React.MouseEvent<HTMLButtonElement>) => {
  return(e.screenX === 0 && e.screenY === 0 && e.clientX === 0 && e.clientY === 0);
};

export default isKeydownClick;
